import { createContext } from '@wordpress/element';
const initialContextValue = {
  location: {},
  goTo: () => {},
  goBack: () => {},
  goToParent: () => {},
  addScreen: () => {},
  removeScreen: () => {},
  params: {}
};
export const NavigatorContext = createContext(initialContextValue);
NavigatorContext.displayName = 'NavigatorContext';